// useFriendQueries.js
// Hooks personalizados para consultas relacionadas con perfiles de amigos usando TanStack Query.
// Separa la lógica de estado async para reutilización en componentes.
// Adaptado para web desde amarsi-app.

import { useQuery } from '@tanstack/react-query';
import { getFriendProfile, getFriendInteractions } from '../services/friendService';

// Hook para obtener el perfil de un amigo.
// Usa useQuery con clave 'friendProfile' y friendId como parámetro.
// Solo ejecuta si friendId está definido.
export const useFriendProfileQuery = (friendId) => {
  return useQuery({
    queryKey: ['friendProfile', friendId],
    queryFn: () => getFriendProfile(friendId),
    enabled: !!friendId,
  });
};

// Hook para obtener las interacciones entre el usuario actual y un amigo.
// Usa useQuery con clave 'friendInteractions' y currentId, friendId.
// Solo ejecuta si ambos IDs están definidos.
export const useFriendInteractionsQuery = (currentId, friendId) => {
  return useQuery({
    queryKey: ['friendInteractions', currentId, friendId],
    queryFn: () => getFriendInteractions(currentId, friendId),
    enabled: !!currentId && !!friendId,
  });
};
